import {
  BUNDLE_SLUG_PLAN_NAMES,
  MONTHLY_TERM,
  PACKAGE_CARD_DESCRIPTIONS,
  PACKAGE_CARD_IS_POPULAR,
  PACKAGE_CARD_SUBHEADERS,
  PACKAGE_HIGHLIGHTS,
  PACKAGE_PRICES_DEFAULT,
  PACKAGE_TITLES,
  PACKAGES,
  YEARLY_TERM,
} from './constants';

export const getBundleCardProps = (bundleName) => ({
  bundleName,
  description: PACKAGE_CARD_DESCRIPTIONS[bundleName],
  header: PACKAGE_TITLES[bundleName],
  highlights: PACKAGE_HIGHLIGHTS[bundleName],
  popularText: PACKAGE_CARD_IS_POPULAR[bundleName] && 'Most popular',
  subHeader: PACKAGE_CARD_SUBHEADERS[bundleName],
});

export const handleOnToggleFeatureList = (
  plan,
  trackEvent,
  trackEventPath = ''
) => {
  if (!trackEvent) {
    return;
  }

  const trackEventPathEnd = plan
    ? 'seeEachCardFeaturesOpened'
    : 'seeAllFeaturesOpened';
  const trackEventFullPath = `${trackEventPath}.${trackEventPathEnd}`;
  const trackEventOptions = plan ? { plan } : {};

  trackEvent(trackEventFullPath, trackEventOptions);
};

export const getBundlePrices = ({
  allPrices = [],
  bundlePlan,
  term = MONTHLY_TERM,
} = {}) =>
  allPrices?.find(
    (bundlePrice = {}) =>
      bundlePrice.bundleSlug === bundlePlan && bundlePrice.term === term
  );

export const buildPackagePricesByTerm = (allPrices = []) => {
  // adding for all main bundle plan names

  return allPrices.length > 0
    ? [...BUNDLE_SLUG_PLAN_NAMES].reduce((acc, key) => {
        // TODO --> clean this up better
        const isEssentials = key.includes(PACKAGES.ESSENTIALS.toLowerCase());
        const isProfessional = key.includes(
          PACKAGES.PROFESSIONAL.toLowerCase()
        );
        const priceKeyWithStandardPlanName = isEssentials
          ? PACKAGES.ESSENTIALS
          : isProfessional
          ? PACKAGES.PROFESSIONAL
          : PACKAGES.STANDARD;

        const bundlePricesMonthly = getBundlePrices({
          allPrices,
          bundlePlan: key,
        });
        const bundlePricesYearly = getBundlePrices({
          allPrices,
          bundlePlan: key,
          term: YEARLY_TERM,
        });

        // this is so select view can read prices as well
        // without a total rewrite
        acc[MONTHLY_TERM] = {
          ...acc[MONTHLY_TERM],
          [key]: bundlePricesMonthly?.price,
          [priceKeyWithStandardPlanName]: bundlePricesMonthly?.price,
        };

        acc[YEARLY_TERM] = {
          ...acc[YEARLY_TERM],
          [key]: bundlePricesYearly?.price,
          [priceKeyWithStandardPlanName]: bundlePricesYearly?.price,
        };

        return acc;
      }, PACKAGE_PRICES_DEFAULT)
    : PACKAGE_PRICES_DEFAULT;
};
